import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const PlatformHome = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [tabType, setTabType] = useState(searchParams.get('type') || 'pickup');
  const [keyword, setKeyword] = useState(searchParams.get('q') || '');
  const [topNotice, setTopNotice] = useState(null);
  const [popularProducts, setPopularProducts] = useState([]);
  const [newProducts, setNewProducts] = useState([]);
  const [todayProducts, setTodayProducts] = useState([]);
  const [saleProducts, setSaleProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    const urlType = searchParams.get('type') || 'pickup';
    setTabType(urlType);
    setKeyword(searchParams.get('q') || '');
  }, [searchParams]);

  useEffect(() => {
    fetchPlatformData(tabType);
    fetchSlides();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabType]);

  const fetchPlatformData = async (type) => {
    setLoading(true);
    try {
      const res = await axios.get(`/api/platform-home?type=${encodeURIComponent(type)}`, {
        withCredentials: true
      });

      const data = res.data || {};
      setTopNotice(data.top_notice || null);
      setPopularProducts(Array.isArray(data.popular_products) ? data.popular_products : []);
      setNewProducts(Array.isArray(data.new_products) ? data.new_products : []);
      setTodayProducts(Array.isArray(data.today_products) ? data.today_products : []);
      setSaleProducts(Array.isArray(data.sale_products) ? data.sale_products : []);
    } catch (err) {
      console.error('플랫폼 홈 조회 실패:', err);
      setTopNotice(null);
      setPopularProducts([]);
      setNewProducts([]);
      setTodayProducts([]);
      setSaleProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchSlides = async () => {
    try {
      const shopId = searchParams.get('shop_id');
      const url = shopId
        ? `/api/shop-info?shop_id=${shopId}`
        : `/api/shop-info`;

      const res = await axios.get(url, { withCredentials: true });
      const data = res.data || {};
      setSlides(Array.isArray(data.slides) ? data.slides : []);
    } catch (err) {
      console.error('슬라이드 조회 실패:', err);
      setSlides([]);
    }
  };

  const handleTabChange = (type) => {
    const next = new URLSearchParams(searchParams);
    next.set('type', type);
    setSearchParams(next);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const q = keyword.trim();

    if (!q) {
      navigate('/search');
      return;
    }

    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const formatPrice = (price) => `${Number(price || 0).toLocaleString()}원`;

  const bindWheelScroll = (e) => {
    e.preventDefault();
    e.currentTarget.scrollLeft += e.deltaY;
  };

  const getSlideImageUrl = (bgImage) => {
    if (!bgImage) return '';
    return bgImage.startsWith('http') ? bgImage : `/api/static/${bgImage}`;
  };

  return (
    <>
      <style>{`
        .platform-page {
          background: #ffffff;
          min-height: 100vh;
          margin-bottom: 0;
          font-family: sans-serif;
          overflow-x: hidden;
        }

        .products-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          padding: 16px 15px 20px 15px;
          overflow-x: hidden;
        }

        .hero-full-wrap {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .main-hero-banner {
          width: 100%;
          height: 350px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          position: relative;
          border-bottom: 0px solid #e5e5e5;
        }

        .hero-overlay {
          width: 100%;
          height: 100%;
          background: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px 16px;
          box-sizing: border-box;
        }

        .hero-content {
          width: 100%;
          max-width: 720px;
          text-align: center;
          color: #fff;
        }

        .hero-text h1 {
          font-size: 2rem;
          font-weight: 700;
          margin: 0 0 8px 0;
          line-height: 1.2;
          box-shadow: none !important;
        }

        .hero-text p {
          font-size: 1rem;
          margin: 0;
          line-height: 1.35;
          box-shadow: none !important;
        }

        .hero-search-box {
          margin-top: 18px;
          width: 100%;
        }

        .hero-search-box .input-group {
          display: flex;
          flex-wrap: nowrap;
          width: 100%;
          align-items: stretch;
          border: 1px solid #000 !important;
          border-radius: 10px;
          overflow: hidden;
          background: rgba(255,255,255,0.96);
          box-shadow: none !important;
        }

        .hero-search-box .input-group-text {
          border: 0 !important;
          background: transparent !important;
          color: #212529;
          font-size: 1rem;
          flex: 0 0 auto;
          padding: 0 12px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: none !important;
        }

        .hero-search-box input.form-control {
          border: 0 !important;
          background: transparent !important;
          min-width: 0;
          flex: 1 1 auto;
          height: 48px;
          padding: 0 8px;
          font-size: 0.95rem;
          box-shadow: none !important;
          outline: none !important;
        }

        .hero-search-box input.form-control:focus {
          border: 0 !important;
          box-shadow: none !important;
          outline: none !important;
        }

        .hero-search-box input.form-control::placeholder {
          color: #8a8f98;
        }

        .hero-search-box .search-btn {
          min-width: 78px;
          flex: 0 0 auto;
          height: 48px;
          border: 0 !important;
          border-left: 1px solid #e5e5e5 !important;
          border-radius: 0 !important;
          background: #ffffff !important;
          color: #111111 !important;
          font-weight: 700;
          white-space: nowrap;
          padding: 0 16px;
          box-shadow: none !important;
        }

        .hero-search-box .search-btn:hover,
        .hero-search-box .search-btn:focus,
        .hero-search-box .search-btn:active {
          background: #ffffff !important;
          color: #111111 !important;
          box-shadow: none !important;
          outline: none !important;
        }

        .notice-wrap {
          margin-top: 2px;
          margin-bottom: 4px;
        }

        .notice-bar {
          display: flex;
          gap: 8px;
          align-items: center;
          padding: 2px 0;
          border: 0;
          font-size: 0.9rem;
          border-radius: 8px;
        }

        .notice-text {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
        }

        .tabs-extend {
          background-color: #ffffff;
          padding-top: 0px;
        }

        #shopTabs {
          border-bottom: 1px solid #dee2e6 !important;
          position: relative;
          background-color: #ffffff;
          padding-left: 0 !important;
          margin-left: 0 !important;
        }

        #shopTabs .nav-item {
          margin-left: 0 !important;
        }

        #shopTabs .nav-link {
          padding-top: 6px !important;
          padding-left: 0 !important;
          border: none !important;
          margin-top: 15px;
          margin-bottom: 0;
          font-weight: 700;
          border-radius: 0;
          color: #212529 !important;
          opacity: 0.6;
          background: transparent;
          cursor: pointer;
        }

        #shopTabs .nav-link b {
          position: relative;
          display: inline-block;
          top: -3px;
        }

        #shopTabs .nav-link.active {
          color: #000 !important;
          opacity: 1;
          border-top: 0 !important;
          border-left: 0 !important;
          border-right: 0 !important;
          border-bottom: none !important;
          background: #fff;
        }

        #shopTabs .nav-link.active b::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -12px;
          width: 100%;
          height: 4px;
          background-color: #000;
          border-radius: 0;
        }

        .horizontal-scroll {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .horizontal-scroll::-webkit-scrollbar {
          display: none;
        }

        .popular-card {
          flex: 0 0 calc((100% - 8px) / 2);
          max-width: calc((100% - 8px) / 2);
          min-width: calc((100% - 8px) / 2);
        }

        .rank-number {
          font-size: 2rem;
          font-weight: 500;
          color: #ddd;
          line-height: 1;
          min-width: 28px;
          text-align: left;
        }

        .rank-new {
          font-size: 0.75rem;
          font-weight: 500;
          color:rgb(162, 9, 9);
          line-height: 1;
          min-width: 30px;
          text-align: left;
        }

        .rank-sale {
          font-size: 0.75rem;
          font-weight: 500;
          color:rgb(134, 134, 134);
          line-height: 1;
          min-width: 30px;
          text-align: left;
        }

        .shop-section {
          background: #fff;
          padding: 12px 0 6px;
          border-radius: 6px;
        }

        .shop-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-left: 0;
          margin-bottom: 10px;
        }

        .shop-header::after {
          content: "";
          display: block;
          flex: 1;
          height: 1px;
          background: #f1f1f1;
          margin-left: 10px;
        }

        .shop-title {
          font-weight: 700;
          font-size: 0.85rem;
        }

        .shop-more {
          font-size: 0.8rem;
          color: #212529;
          text-decoration: none;
          white-space: nowrap;
        }

        .product-box {
          border-radius: 0;
          box-shadow: none !important;
          margin-bottom: 15px;
        }

        .product-box img {
          height: auto;
          object-fit: cover;
          width: 100%;
          display: block;
        }

        .product-info {
          border: 0 !important;
          box-shadow: none !important;
          padding: 4px 0 0 0;
          background-color: #ffffff;
        }

        .product-info .product-name {
          font-weight: 700;
          font-size: 0.95rem;
          margin-bottom: 0;
          color: #222;
        }

        .product-info .price {
          font-weight: 700;
          font-size: 0.95rem;
          color: #666;
        }

        .loading-layer {
          opacity: 0.5;
          transition: opacity .2s ease;
        }

        @media (max-width: 767.98px) {
          .products-wrapper {
            padding: 12px 15px 20px 15px;
          }

          .main-hero-banner {
            height: 190px;
            background-position: center center;
          }

          .hero-overlay {
            background: transparent;
            align-items: center !important;
            justify-content: center !important;
            padding: 16px 14px !important;
          }

          .hero-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
            text-align: center !important;
            transform: translateY(-20px);
          }

          .hero-text h1 {
            font-size: 1.2rem;
            margin-bottom: 4px;
          }

          .hero-text p {
            font-size: 0.82rem;
          }

          .hero-text {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }

          .hero-search-box {
            margin-top: auto;
          }

          .hero-search-box .input-group {
            border-radius: 18px;
          }

          .hero-search-box .input-group-text {
            height: 40px;
            padding: 0 10px;
            font-size: 0.95rem;
          }

          .hero-search-box input.form-control {
            height: 40px;
            font-size: 0.88rem;
            padding: 0 6px;
          }

          .hero-search-box .search-btn {
            display: none !important;
          }

          .notice-wrap {
            margin-top: 2px;
          }
        }

        @media (max-width: 576px) {
          .shop-section {
            padding: 8px 0 4px;
          }
        }

        @media (min-width: 768px) {
          .popular-card {
            flex: 0 0 calc((100% - 16px) / 3);
            max-width: calc((100% - 16px) / 3);
            min-width: calc((100% - 16px) / 3);
          }
        }

        @media (max-width: 767.98px) {
          .carousel-control-prev,
          .carousel-control-next {
            display: none !important;
          }
        }

        .hero-full-wrap {
          position: relative;
        }

        .hero-search-fixed {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 20px;
          width: 92%;
          max-width: 720px;
          z-index: 10;
        }
        
        .image-rank {
          position: absolute;
          top: 7px;
          left: 8px;

          width: 24px;
          height: 24px;

          background: rgba(0, 0, 0, 0.07);
          color: #fff;

          border-radius: 50%;

          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 14px;
          font-weight: 700;

          z-index: 2;
        }
      `}</style>

      <div className="platform-page">
        {slides.length > 0 && (
          <div className="hero-full-wrap">
            <div id="heroCarousel" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-inner">
                {slides.map((s, i) => (
                  <div key={i} className={`carousel-item ${i === 0 ? 'active' : ''}`}>
                    <div
                      className="main-hero-banner"
                      style={{
                        backgroundImage: `url('${getSlideImageUrl(s.bg_image)}')`
                      }}
                    >
                      <div className="hero-overlay">
                        <div className="hero-content">
                          <div className="hero-text">
                            <h1>{s.title}</h1>
                            {s.subtitle && <p>{s.subtitle}</p>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {slides.length > 1 && (
                <>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#heroCarousel"
                    data-bs-slide="prev"
                  >
                    <span className="carousel-control-prev-icon"></span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#heroCarousel"
                    data-bs-slide="next"
                  >
                    <span className="carousel-control-next-icon"></span>
                  </button>
                </>
              )}
            </div>

            <form onSubmit={handleSearch} className="hero-search-fixed hero-search-box">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  placeholder="상품명 또는 가게명을 검색"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                />

                <button type="submit" className="btn search-btn">
                  검색
                </button>
              </div>
            </form>
          </div>
        )}

        <div className="products-wrapper">
          {/*
          {topNotice && (
            <div
              className="notice-wrap p-3 mb-0 rounded"
              style={{ backgroundColor: '#f5f5f5' }}
            >
              <Link
                to={`/notice/${topNotice.id}`}
                className="notice-bar text-decoration-none text-dark"
              >
                <span className="notice-text">{topNotice.title}</span>
                <i
                  className="bi bi-chevron-right ms-auto"
                  style={{ fontSize: '0.7rem' }}
                ></i>
              </Link>
            </div>
          )}
          */}

          {/*
          <div className="mb-4">
            <div className="tabs-extend">
              <ul className="nav nav-tabs mb-3" id="shopTabs">
                <li className="nav-item">
                  <button
                    type="button"
                    className={`nav-link ${tabType === 'pickup' ? 'active' : ''}`}
                    onClick={() => handleTabChange('pickup')}
                  >
                    <b>매장 픽업</b>
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    type="button"
                    className={`nav-link ${tabType === 'delivery' ? 'active' : ''}`}
                    onClick={() => handleTabChange('delivery')}
                  >
                    <b>배달 수령</b>
                  </button>
                </li>
              </ul>
            </div>
          </div>
           */}

          <div id="shopProductsArea" className={loading ? 'loading-layer' : ''}>
            {popularProducts.length > 0 && (
              <div className="mt-3 mb-2">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="fw-bold" style={{ fontSize: '1.05rem' }}>인기상품</div>
                </div>

                <div
                  className="d-flex gap-3 overflow-auto pb-2 horizontal-scroll"
                  onWheel={bindWheelScroll}
                >
                  {popularProducts.map((p, idx) => (
                    <Link
                      key={p.id}
                      to={`/product/${p.id}?shop_id=${p.shop_id}`}
                      className="popular-card text-decoration-none text-dark"
                    >
                      <div className="border-0">
                        <div className="ratio ratio-1x1">
                          <img
                            src={p.image_url}
                            alt={p.name}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            onError={(e) => {
                              e.target.src = '/api/static/images/noimage.png';
                            }}
                          />
                          <div className="image-rank">
                            {idx + 1}
                          </div>
                        </div>

                        <div className="pt-2 d-flex gap-2 align-items-start">
                          <div>
                            <div style={{ fontSize: '0.8rem', color: '#666', lineHeight: '1.1' }}>
                              {p.shop_name}
                            </div>
                            <div className="fw-bold" style={{ fontSize: '0.95rem', lineHeight: '1.2' }}>
                              {p.name}
                            </div>
                            <div className="fw-bold" style={{ fontSize: '0.95rem', color: '#666' }}>
                              {p.price < p.original_price ? (
                                <>
                                  <del style={{ fontSize: '0.7rem', color: '#999' }}>{formatPrice(p.original_price)}</del>
                                  <div>{formatPrice(p.price)}</div>
                                </>
                              ) : (
                                <div>{formatPrice(p.original_price)}</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}

            {newProducts.length > 0 && (
              <div className="mt-4 mb-2">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="fw-bold" style={{ fontSize: '1.05rem' }}>최신상품</div>
                </div>

                <div
                  className="d-flex gap-3 overflow-auto pb-2 horizontal-scroll"
                  onWheel={bindWheelScroll}
                >
                  {newProducts.map((p) => (
                    <Link
                      key={p.id}
                      to={`/product/${p.id}?shop_id=${p.shop_id}`}
                      className="popular-card text-decoration-none text-dark"
                    >
                      <div className="border-0">
                        <div className="ratio ratio-1x1 position-relative">
                          <img
                            src={p.image_url}
                            alt={p.name}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            onError={(e) => {
                              e.target.src = '/api/static/images/noimage.png';
                            }}
                          />
                        </div>

                        <div className="pt-2 d-flex gap-2 align-items-start">
                          <div>
                            <div style={{ fontSize: '0.8rem', color: '#666', lineHeight: '1.1' }}>
                              <span className="rank-new">NEW</span>
                            </div>
                            <div className="fw-bold" style={{ fontSize: '0.95rem', lineHeight: '1.2' }}>
                              {p.name}
                            </div>
                            <div className="fw-bold" style={{ fontSize: '0.95rem', color: '#666' }}>
                              {p.price < p.original_price ? (
                                <>
                                  <del style={{ fontSize: '0.7rem', color: '#999' }}>{formatPrice(p.original_price)}</del>
                                  <div>{formatPrice(p.price)}</div>
                                </>
                              ) : (
                                <div>{formatPrice(p.original_price)}</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}

            {saleProducts.length > 0 && (
              <div className="mt-4 mb-2">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="fw-bold" style={{ fontSize: '1.05rem' }}>
                    세일상품
                  </div>
                </div>

                <div
                  className="d-flex gap-3 overflow-auto pb-2 horizontal-scroll"
                  onWheel={bindWheelScroll}
                >
                  {saleProducts.map((p) => (
                    <Link
                      key={p.id}
                      to={`/product/${p.id}?shop_id=${p.shop_id}`}
                      className="popular-card text-decoration-none text-dark"
                    >
                      <div className="border-0">
                        <div className="ratio ratio-1x1 position-relative">
                          <img
                            src={p.image_url}
                            alt={p.name}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            onError={(e) => {
                              e.target.src = '/api/static/images/noimage.png';
                            }}
                          />
                        </div>

                        <div className="pt-2 d-flex gap-2 align-items-start">
                          <div>
                            <div style={{ fontSize: '0.8rem', color: '#666', lineHeight: '1.1' }}>
                              <span className="rank-sale">SALE</span>
                            </div>

                            <div className="fw-bold" style={{ fontSize: '0.95rem', lineHeight: '1.2' }}>
                              {p.name}
                            </div>

                            <div className="fw-bold" style={{ fontSize: '0.95rem', color: '#666' }}>
                              <del style={{ fontSize: '0.7rem', color: '#999' }}>{formatPrice(p.original_price)}</del>
                              <div>{formatPrice(p.price)}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}

            {todayProducts.length === 0 && (
              <div className="text-center text-muted py-5"> </div>
            )}

{/*
            {todayProducts.map((shop) => (
              <div className="mt-3 mb-0 shop-section" key={shop.shop_id}>
                <div className="shop-header mb-3">
                  <span className="shop-title">{shop.shop_name} </span>
                  <Link to={`/shop?shop_id=${shop.shop_id}&type=${tabType}`} className="shop-more">
                    [전체상품]
                  </Link>
                </div>

                <div className="row row-cols-2 row-cols-md-3 g-3 g-md-4">
                  {(shop.items || [])
                    .slice()
                    .sort((a, b) => a.id - b.id)
                    .map((row) => (
                      <div className="col" style={{ minWidth: '160px' }} key={row.id}>
                        <Link
                          to={`/product/${row.id}?shop_id=${shop.shop_id}`}
                          className="text-decoration-none text-dark"
                        >
                          <div className="product-box h-100 border-0 rounded-0 shadow-sm">
                            <img
                              src={row.image_url}
                              className="card-img-top rounded-0"
                              alt={row.name}
                              onError={(e) => {
                                e.target.src = '/api/static/images/noimage.png';
                              }}
                            />
                            <div className="product-info">
                              <div className="product-name">{row.name}</div>
                              <div className="price">
                                {row.price < row.original_price ? (
                                  <>
                                    <del style={{ fontSize: '0.7rem', color: '#999' }}>{formatPrice(row.original_price)}</del>
                                    <div>{formatPrice(row.price)}</div>
                                  </>
                                ) : (
                                  <div>{formatPrice(row.original_price)}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                </div>
              </div>
            ))}
*/}
          </div>
        </div>
      </div>
    </>
  );
};

export default PlatformHome;